import { apiSlice } from "../../app/api/apiSlice";

export const enhancedConditionUploadFileForS3FallbackApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		enhancedConditionUploadFileForS3Fallback: builder.mutation({
			query: (credentials) => ({
				url: `/api/v1/loan/enhanced_condition_upload_file_for_s3_fallback/${credentials?.loanGuid}/`,
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useEnhancedConditionUploadFileForS3FallbackMutation } =
	enhancedConditionUploadFileForS3FallbackApiSlice;
